import "./about.css";
import React, { useEffect, useState } from "react";
import "react-multi-carousel/lib/styles.css";

import star from "./assets/star.png";
import people from "./assets/4people.png";

import andyNote from "./assets/andyNote.png";
import andyCD from "./assets/andyCD.png";

import rileyNote from "./assets/rileyNote.png";
import rileyCD from "./assets/rileyCD.png";

import camiNote from "./assets/camiNote.png";
import camiCD from "./assets/camiCD.png";

import lucyNote from "./assets/lucyNote.png";
import lucyCD from "./assets/lucyCD.png";

import microphone from "./assets/microphone.png";

import Header from "../header/header";
import * as aboutService from "../../services/about-service";

function About() {
  const [missionStatement, setMissionStatement] = useState();
  const [members, setMembers] = useState();
  const fetchMissionStatement = async () => {
    const response = await aboutService.fetchMissionStatement();
    setMissionStatement(response.data);
  };
  const fetchMembers = async () => {
    const response = await aboutService.fetchMembers();
    setMembers(response.data);
  };
  useEffect(() => {
    fetchMissionStatement();
    fetchMembers();
  }, []);
  return (
    <div>
      <Header />
      <div className="about-header interlude-text-color mudstone-sans">
        <div className="about-header-shader"></div>
        <div className="main-header">MEET THE BAND</div>
      </div>
      {/* <div className="banner">
        <div className="parent">
          <img className="meetBandPhoto" src={Group1} alt="description" />
        </div>
        <div className="meetCherry">Meet The Band</div>
      </div> */}
      <div className="missionStatement">
        <img className="starDoodle" src={star} alt="star doodle" />
        <h1>Mission Statement</h1>
        {missionStatement &&
          missionStatement.statement
            .trim()
            .split("\n")
            .map((par) => <p className="">{par}</p>)}
        <img className="peopleDoodle" src={people} alt="people doodle" />
      </div>
      {members && (
        <div className="members">
          <div className="andy">
            <img
              className="andyPhoto memberPhoto"
              src={`./assets/members/` + members.andy?.image}
              alt="description"
            />
            <div className="andynote note">
              <div class="descriptionOverlay">
                <p className="andyDescription">
                  <div className="name">{members.andy?.name.toUpperCase()}</div>
                  <br></br>
                  <div className="instrument">
                    {" "}
                    Instrument: <br></br>
                    {members.andy?.instrument}
                  </div>
                </p>
              </div>
              <img className="andynote note" src={andyNote} alt="description" />
            </div>
            <a
              href={members.andy?.playlist}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="cd andyCD" src={andyCD} alt="description" />
            </a>
          </div>
          <div className="riley">
            <img
              className="rileyPhoto memberPhoto"
              src={`./assets/members/` + members.riley?.image}
              alt="description"
            />
            <div className="rileynote note">
              <div class="descriptionOverlay">
                <p className="rileyDescription">
                  <div className="name">
                    {members.riley?.name.toUpperCase()}
                  </div>
                  <br></br>
                  <div className="instrument">
                    {" "}
                    Instrument:<br></br>
                    {members.riley?.instrument}
                  </div>
                </p>
              </div>
              <img
                className="rileynote note"
                src={rileyNote}
                alt="description"
              />
            </div>
            <a
              href={members.riley?.playlist}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="cd rileyCD" src={rileyCD} alt="description" />
            </a>
          </div>
          <div className="lucy">
            <img
              className="lucyPhoto memberPhoto"
              src={`./assets/members/` + members.lucy?.image}
              alt="description"
            />
            <div className="lucynote note">
              <div class="descriptionOverlay">
                <p className="lucyDescription">
                  <div className="name">{members.lucy?.name.toUpperCase()}</div>
                  <br></br>
                  <div className="instrument">
                    {" "}
                    Instrument: <br></br>
                    {members.lucy?.instrument}
                  </div>
                </p>
              </div>
              <img className="lucynote note" src={lucyNote} alt="description" />
            </div>
            <a
              href={members.lucy?.playlist}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="cd lucyCD" src={lucyCD} alt="description" />
            </a>
          </div>
          <div className="cami">
            <img
              className="camiPhoto memberPhoto"
              src={`./assets/members/` + members.cami?.image}
              alt="description"
            />
            <div className="caminote note">
              <div class="descriptionOverlay">
                <p className="camiDescription">
                  <div className="name">{members.cami?.name.toUpperCase()}</div>
                  <br></br>
                  <div className="instrument">
                    {" "}
                    Instrument: <br></br>
                    {members.cami?.instrument}
                  </div>
                </p>
              </div>
              <img className="caminote note" src={camiNote} alt="description" />
            </div>{" "}
            <a
              href={members.cami?.playlist}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="cd camiCD" src={camiCD} alt="description" />
            </a>
          </div>
          <div className="doodles">
            <img className="microphone" src={microphone} alt="microphone" />
          </div>
        </div>
      )}
    </div>
  );
}

export default About;
